import { render, staticRenderFns } from "./UserGroupManage.vue?vue&type=template&id=6a6d5f32&scoped=true&"
import script from "./UserGroupManage.vue?vue&type=script&lang=js&"
export * from "./UserGroupManage.vue?vue&type=script&lang=js&"
import style0 from "./UserGroupManage.vue?vue&type=style&index=0&id=6a6d5f32&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a6d5f32",
  null
  
)

export default component.exports